import axios from 'axios';
import { del, get, post, put } from './api_helper';
import * as url from './url_helper';

// get Filter List
export const getInvoices = async () => {
  const response = await fetch(url.GET_INVOICES).then((response) =>
    response.json(),
  );

  return response;
};

export const getInvoiceDetail = async () => {
  const response = await fetch(url.GET_INVOICES, {
    method: 'GET',
  }).then((res) => res.json());

  return response;
};
